import { CurrencyPipe, NgFor, NgIf } from "@angular/common";
import { Component, Input, Output, EventEmitter, inject } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { provideNgxMask, NgxMaskDirective } from "ngx-mask";
import { AddCatalogItemPlan } from "src/app/models/catalogs/catalog";
import { GetFinancialParameter } from "src/app/models/financial-parameter/get";
import { DropdownOption } from "src/app/models/shared/dropdown-option";
import { FinancialParameterService } from "src/app/services/financial-parameter.service";
import Swal from "sweetalert2";

@Component({
  selector: "app-pricing-step",
  standalone: true,
  imports: [FormsModule, NgIf, NgFor, NgxMaskDirective, CurrencyPipe],
  providers: [provideNgxMask()],
  templateUrl: "./pricing-step.component.html",
  styleUrls: ["./pricing-step.component.css"],
})
export class PricingStepComponent {
  @Input() public isReadonly: boolean = false;
  @Input() data: any = {};
  @Input() financialParameter: GetFinancialParameter | null = null;
  @Input() periodUnitOptions: DropdownOption[] = [];
  @Output() dataChange = new EventEmitter<any>();

  basePrice = null;
  appliesITBIS = false;

  plans: AddCatalogItemPlan[] = [
    {
      id: null,
      versionId: 0,
      periodQty: 0,
      price: 0,
      name: "",
      isActive: true,
      isDefault: true,
      appliesITBIS: true,
      periodUnitId: null,
    },
  ];

  ngOnInit() {
    this.basePrice = this.data?.basePrice;
    this.appliesITBIS = this.data?.appliesITBIS ?? false;

    if (this.data?.plans?.length > 0) {
      this.plans = this.data?.plans;
    } else {
      if (this.periodUnitOptions?.length > 0) {
        const firstId = this.periodUnitOptions[0].id;
        this.plans = this.plans.map((p) => ({
          ...p,
          periodUnitId: p.periodUnitId ?? firstId,
        }));
      }
      this.updateData();
    }
  }

  addPlan() {
    const defaultUnit = this.periodUnitOptions?.[0]?.id ?? null;
    this.plans.push({
      id: null,
      versionId: 0,
      periodQty: 0,
      price: 0,
      isActive: true,
      isDefault: false,
      appliesITBIS: this.appliesITBIS,
      periodUnitId: defaultUnit,
      name: "",
    });
    this.updateData();
  }

  removePlan(index: number) {
    if (this.plans.length > 1) {
      this.plans.splice(index, 1);
      this.updateData();
    }

    if (this.plans.length === 1) {
      this.setDefault(0);
    }
  }

  setDefault(index: number) {
    this.plans = this.plans.map((p, i) => ({ ...p, isDefault: i === index }));
    this.updateData();
  }

  updateData() {
    const updated = {
      basePrice: this.basePrice,
      appliesITBIS: this.appliesITBIS,
      plans: this.plans,
    };
    this.dataChange.emit(updated);
  }

  validatePeriodQty(index: number) {
    const plan = this.plans[index];
    if (!plan.periodQty || plan.periodQty < 1) {
      plan.periodQty = 1;
    }
    this.updateData();
  }

  validate() {
    this.updateData();

    if (!this.basePrice || this.basePrice <= 0) {
      Swal.fire({
        icon: "warning",
        title: "Precio base requerido",
        text: "Debes ingresar un precio base válido mayor que 0.",
      });
      return false;
    }

    for (const plan of this.plans) {
      if (
        !plan.name?.trim() ||
        !plan.periodQty ||
        plan.periodQty <= 0 ||
        !plan.price ||
        plan.price <= 0 ||
        !plan.periodUnitId
      ) {
        Swal.fire({
          icon: "warning",
          title: "Campos incompletos",
          text: "Todos los planes deben tener nombre, periodo, precio y unidad de periodo.",
        });
        return false;
      }
    }

    const hasActive = this.plans.some((p) => p.isActive);
    if (!hasActive) {
      Swal.fire({
        icon: "warning",
        title: "Plan requerido",
        text: "Debe haber al menos un plan activo.",
      });
      return false;
    }

    return true;
  }
}
